import { Card, Divider, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Accordion, AccordionSummary, useStyles } from "../TabReviewStyle";
import RateArticle from "./rate/RateArticle";

interface ArticleCommentsType {
  data: any;
  isExpanded: any;
  setIsExpanded: any;
  expandObject: any;
  makeReact: any;
  postRating: any;
  editorView: boolean;
  uniqueReviewers: any;
}

export default function ArticleComments(props: ArticleCommentsType) {
  const { data, isExpanded, setIsExpanded, expandObject, makeReact, postRating, editorView, uniqueReviewers } = props;
  const classes = useStyles();

  const headerGray = [classes.reviewHeader, classes.colorGrayLight].join(" ");
  const textGray = [classes.reviewText, classes.colorGrayLight].join(" ");

  return (
    <Card className={classes.root} square>
      <Typography variant="subtitle1" align="left">
        <b>{"Comments"}</b>
      </Typography>
      {expandObject &&
        data.map((item: any, index: number) => {
          return (
            <Accordion
              square
              key={item.id}
              expanded={isExpanded(expandObject, item.reviewer.email)}
              onChange={(e: any) => {
                setIsExpanded(expandObject, item.reviewer.email, !isExpanded(expandObject, item.reviewer.email));
              }}
            >
              <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">
                  {"Reviewer #" +
                    (uniqueReviewers.indexOf(item.reviewer.email) + 1) +
                    " " +
                    (editorView
                      ? item.reviewer.title + " " + item.reviewer.firstName + " - " + item.reviewer.lastName
                      : "")}
                </Typography>
              </AccordionSummary>
              {item.review ? (
                <div style={{ display: "flex", flexDirection: "column", padding: "10px" }}>
                  <div className={headerGray}>
                    <b>{"General Comment"}</b>
                  </div>
                  <div className={textGray}>{makeReact(item?.review?.general ?? "")}</div>
                  <Divider />
                  <div className={classes.reviewHeader}>
                    <b>{"Major Comment"}</b>
                  </div>
                  <div className={classes.reviewText}>{makeReact(item?.review?.major ?? "")}</div>

                  <div className={headerGray}>
                    <b>{"Minor Comment"}</b>
                  </div>
                  <div className={textGray}>{makeReact(item?.review?.minor ?? "")}</div>

                  <div className={classes.reviewHeader}>
                    <b>{"Abstract Comment"}</b>
                  </div>
                  <div className={classes.reviewText}>{makeReact(item?.review?.commentsAbstract ?? "")}</div>

                  <div className={headerGray}>
                    <b>{"Table Comment"}</b>
                  </div>
                  <div className={textGray}>{makeReact(item?.review?.commentsTables ?? "")}</div>

                  <div className={classes.reviewHeader}>
                    <b>{"Figure Comment"}</b>
                  </div>
                  <div className={classes.reviewText}>{makeReact(item?.review?.commentsFigures ?? "")}</div>

                  <div className={headerGray}>
                    <b>{"Reference Comment"}</b>
                  </div>
                  <div className={textGray}>{makeReact(item?.review?.commentsReferences ?? "")}</div>

                  {editorView && (
                    <>
                      <div className={classes.reviewHeader}>
                        <b>{"Comment to the editor"}</b>
                      </div>
                      <div>{makeReact(item?.review?.commentsToEditor ?? "")}</div>
                      <Divider />
                      <RateArticle
                        reviewId={item.id}
                        rating={item?.review?.reviewRating?.rating ?? undefined}
                        postRating={postRating}
                      />
                    </>
                  )}
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", padding: "10px" }}>
                  {"There is no review to show..."}
                </div>
              )}
            </Accordion>
          );
        })}
    </Card>
  );
}
